<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.addContact.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.addContact.requiredHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <!-- User Search Section -->
    <div class="row mb-3">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.addContact.searchUser' | translate }}</label>
        <div class="position-relative">
          <app-input-component
            [type]="'text'"
            [placeholder]="'manageEvent.addContact.searchPlaceholder' | translate"
            [value]="userSearch"
            (valueChange)="onSearchInput($event)"
            [disabled]="selectedUser != null"
          />
          <div *ngIf="selectedUser" class="selected-user-badge mt-2">
            <span class="badge bg-primary d-inline-flex align-items-center gap-2">
              <i class="fa fa-user"></i>
              {{ selectedUser.full_name }} ({{ selectedUser.email }})
              <i class="fa fa-times cursor-pointer" (click)="clearSelectedUser()"></i>
            </span>
          </div>
          <div *ngIf="showResults && userSearchResults.length > 0" class="search-results-dropdown">
            <div *ngFor="let user of userSearchResults"
                 class="search-result-item"
                 (click)="selectUser(user)">
              <div class="d-flex align-items-center">
                <i class="fa fa-user me-2"></i>
                <div>
                  <div class="fw-medium">{{ user.full_name }}</div>
                  <small class="text-muted">{{ user.email }}</small>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isSearching" class="search-loading">
            <i class="fa fa-spinner fa-spin"></i> {{ 'common.searching' | translate }}
          </div>
          <div *ngIf="showResults && userSearchResults.length === 0 && !isSearching && userSearch.length >= 2" class="search-no-results">
            {{ 'manageEvent.addContact.noUsersFound' | translate }}
          </div>
        </div>
      </div>
    </div>

    <hr class="my-3">

    <div class="row">
      <h3>{{ 'manageEvent.addContact.contactInfo' | translate }}</h3>
      <small *ngIf="!selectedUser" class="text-muted mb-2">{{ 'manageEvent.addContact.manualEntryHint' | translate }}</small>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="('manageEvent.addContact.firstName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.addContact.firstNamePlaceholder' | translate"
          [(value)]="first_name"
          [disabled]="selectedUser != null"
          [invalid]="isFirstNameInvalid"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="('manageEvent.addContact.lastName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.addContact.lastNamePlaceholder' | translate"
          [(value)]="last_name"
          [disabled]="selectedUser != null"
          [invalid]="isLastNameInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="'manageEvent.addContact.email' | translate"
          [type]="'email'"
          [placeholder]="'manageEvent.addContact.emailPlaceholder' | translate"
          [(value)]="email"
          [disabled]="selectedUser != null"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="'manageEvent.addContact.phone' | translate"
          [type]="'tel'"
          [placeholder]="'manageEvent.addContact.phonePlaceholder' | translate"
          [(value)]="phone"
          [disabled]="selectedUser != null"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.addContact.role' | translate }} <span class="text-danger">*</span></label>
        <app-selectorini
          [placeholder]="'manageEvent.addContact.rolePlaceholder' | translate"
          [options]="roles"
          [disabled]="loadingRoles"
          [valueKey]="'role_id'"
          [displayKey]="'role_name'"
          [(value)]="role_id"
          [invalid]="isRoleInvalid"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.addContact.saveContact' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
